import { MingcuteUserAddFill } from '../../../assets/icons/Icons'
import Refetch from '../../ui/Refetch'
import { useDispatch } from 'react-redux'
import { setTypeModal, setTypeOfShowModalType } from '../../../features/modal/modalSlice'
import { useMasterData } from '../../../hooks/api/useMasterData'

export default function StaffOptionSorting() {

    const { refetchUsersData } = useMasterData()
    const dispatch = useDispatch()
    const handleCreateStaff = () => {
        dispatch(setTypeModal('newStaff'));
        dispatch(setTypeOfShowModalType('staffModal'));
    }

    return (
        <div className='w-full flex flex-col'>
            <div className={`flex justify-between`}>
                <p className='text-sm font-medium flex items-center justify-center'>Staff Management</p>
                <div className='flex space-x-2'>
                    <button 
                        onClick={handleCreateStaff}
                        className='flex items-center text-sm font-medium rounded transition px-2 py-1 bg-cbColor text-white shadow-md'
                    >
                        <MingcuteUserAddFill color='#ffff' width={19} height={19}/>
                    </button>
                    {/* <Refetch refetch={refetchUsersData} size={23} btnStyle={''}/> */}
                </div>
            </div>
        </div>
    )
}
